import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import dayjs from 'dayjs';

//Servicios

//Componentes
import Spinner from '../../components/spinner/Spinner';
import DJTVList from './DJTVList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

function DJTVListContainer() {
    const { token, settings, user, masters, viniedos } = useGlobalContext();
    const { register, handleSubmit, watch, setError, formState } = useForm({
        defaultValues: { myViniedo: 0 },
    });
    const Navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [DJTVListData, setDJTVListData] = useState([]);

    const EnableBtn = parseInt(watch('myViniedo'));

    useEffect(() => {
        // const getMyDJTV = async () => {
        //     try {
        //         setLoader(true);
        //         const myDJTVs = await DJTVService.all({
        //             token,
        //             usuarioId: user.id,
        //             // serie: parseInt(dayjs(new Date()).format('YYYY')),
        //         });
        //         if (myDJTVs) {
        //             setDJTVListData(myDJTVs.data);
        //             setTableData(buildTableData(myDJTVs.data));
        //         }
        //         setLoader(false);
        //     } catch (err) {
        //         setLoader(false);
        //     }
        // };
        // if (user.tipo !== 3) getMyDJTV();
    }, []);

    /**Funcion que crea el objeto para pasarle al componente tabla y listar las DJCPs*/
    const buildTableData = (
        data = [
            {
                id: 1,
                viniedo: '',
                fecha: '',
                fecha_cierre: '',
                timbre: '',
                habilitada: '',
                total_kilos: '',
                cerrada: '',
            },
        ]
    ) => {
        return {
            title: 'Declaraciones de Transferencia de Viñedo',
            headers: [
                'ID',
                'Viñedo',
                'Fecha',
                'Timbre',
                'Habilitada',
                'Kilos Totales',
                'Cerrada',
                ' ',
            ],
            pagination: 10,
            data: data?.map((dj) => {
                return {
                    id: `${dj.serie}-P-${dj.numero}`,
                    viniedo: dj.viniedo,
                    fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                    timbre: dj.timbre ? 'PAGO' : 'NO PAGO',
                    habilitada: masters.HabilitationTypes?.find(
                        (ht) => ht.id === dj.habilitada
                    )?.nombre.replace('_', ' '),
                    kilosTotales: dj.total_Kilos,
                    cerrada: !dj.fecha_cierre ? 'NO' : dj.fecha_cierre,
                    icons: (
                        <div>
                            <Link
                                to={
                                    RoutesApp.Declaraciones
                                        .transferenciaViniedo + dj.id
                                }
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={right_arrow}
                                    title="Visualizar"
                                    alt="Visualizar"
                                />
                            </Link>
                            <Link
                                to={
                                    RoutesApp.Declaraciones
                                        .nuevaTransferenciaViniedo + dj.id
                                }
                                className="table-icon_container"
                            >
                                <img
                                    className="table-icon"
                                    src={pencil}
                                    title="Editar"
                                    alt="Editar"
                                />
                            </Link>
                        </div>
                    ),
                };
            }),
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    const newDJTV = async (data) => {
        try {
            setLoader(true);

            // const newDJTV = await DJTVService.create({
            //     token,
            //     viniedoId: data.myViniedo,
            // });

            // if (newDJTV) {
            //     Navigate(
            //         RoutesApp.Declaraciones.nuevaCosechaEfectiva +
            //             newDJTV.data.cabecera.id
            //     );
            // }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <DJTVList
            functions={{
                register,
                handleSubmit,
                watch,
                setError,
                formState,
                newDJTV,
            }}
            states={{
                DJTVListData,
                tableData,
                viniedos,
                settings,
                EnableBtn,
            }}
        />
    );
}

export default DJTVListContainer;
